import React from "react";

const Adim = ({ page }) => {
  return (
    <div className="w-full flex flex-col gap-4 items-center">
      <p className="text-grayy"><span className="text-dark">{page=== "onay" ? "Adım 2" : page==="kariyer_bilgileri" ? "Adım 3" : "Adım 1"}</span>-3</p>
      <div className=" bg-rounded-md w-full h-2 bg-progressGray">
        <div
          className={`bg-darkerGreen rounded-md ${
            page === "onay" ? " w-[66%]" : page === "kariyer_bilgileri" ? "w-[100%]": "w-[33%]"
          } h-2`}
        ></div>
      </div>
    </div>
  );
};

export default Adim;
